import moment from 'moment';

const FIELD_PREFIX = 'unlimitedBoosts.';
const DATE_FORMAT = 'D MMM YYYY, HH:mm [UTC]';

const formatDate = (date: unknown): string => moment.utc(date as string).format(DATE_FORMAT);

/**
 * Label suffix for an unlimited boost balance field: whether the boost is running, and until when the
 * balance can still be activated. A balance past its expiration is still stored (and shown in the field)
 * but the game refuses to activate it (UNLIMITED_BOOST_EXPIRED), which is easy to miss for support.
 */
export function getUnlimitedBoostDetails(
  unlimitedBoosts: Record<string, unknown> | null | undefined,
  fieldKey: string
): string | undefined {
  if (!unlimitedBoosts || !fieldKey.startsWith(FIELD_PREFIX)) {
    return undefined;
  }
  // unlimitedBoosts.unlimitedBoostCoinsAndXpBalance -> unlimitedBoostCoinsAndXp
  const boostPrefix = fieldKey.slice(FIELD_PREFIX.length).replace(/Balance$/, '');
  const balance = unlimitedBoosts[`${boostPrefix}Balance`];
  const balanceExpiration = unlimitedBoosts[`${boostPrefix}BalanceExpiration`];
  const end = unlimitedBoosts[`${boostPrefix}End`];
  const now = moment();

  const parts: string[] = [];
  if (end && moment(end as string).isAfter(now)) {
    parts.push(`active until ${formatDate(end)}`);
  }
  if (typeof balance === 'number' && balance > 0 && balanceExpiration) {
    parts.push(
      moment(balanceExpiration as string).isAfter(now)
        ? `activate before ${formatDate(balanceExpiration)}`
        : `EXPIRED ${formatDate(balanceExpiration)}, re-save to renew for 24h`
    );
  }
  return parts.length > 0 ? parts.join(' · ') : undefined;
}
